// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Na-F","badges":"styles_badges__1rE5_"};